export { SplashScreen } from "./SplashScreen";
export { SPLASH_BOOT_SCRIPT, SPLASH_ENABLED } from "./data";
